<div class="py-4 container-fluid teach-compensation-page">
  <h4 class="mb-4 teach-compensation-title">
    การจัดการคำขอสอนชดเชย - คำขอสอนชดเชย
  </h4>

  <div class="teach-compensation-card">
    <div class="teach-compensation-card-body">
      <div class="teach-compensation-toolbar" [formGroup]="form">
        <div class="teach-compensation-filters">
          <div class="teach-compensation-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="teach-compensation-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="teach-compensation-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        @if (!isSuperAdmin()) {
          <div class="teach-compensation-create-action">
            <button
              type="button"
              class="btn teach-compensation-add-button"
              [disabled]="!canCreateSubmission()"
              [attr.aria-describedby]="creationBlockedMessage() ? 'compensation-lock-message' : null"
              (click)="onCreateSubmission()"
            >
              <img
                src="assets/media/icons/svg/add-item.svg"
                class="teach-compensation-toolbar-icon"
                alt=""
                aria-hidden="true"
              />
              <span>สร้างคำขอสอนชดเชย</span>
            </button>

            @if (creationBlockedMessage()) {
              <span id="compensation-lock-message" class="teach-compensation-lock-message">
                {{ creationBlockedMessage() }}
              </span>
            }
          </div>
        }
      </div>

      <div class="segmented-tabs segmented-tabs--sm teach-compensation-tabs" role="tablist" aria-label="สถานะคำขอสอนชดเชย">
        <button
          type="button"
          role="tab"
          class="segmented-tab teach-compensation-tab"
          [class.active]="activeTab() === 'all'"
          [attr.aria-selected]="activeTab() === 'all'"
          (click)="onTabChange('all')"
        >
          รายการทั้งหมด
        </button>
        <button
          type="button"
          role="tab"
          class="segmented-tab teach-compensation-tab"
          [class.active]="activeTab() === 'pending'"
          [attr.aria-selected]="activeTab() === 'pending'"
          (click)="onTabChange('pending')"
        >
          รอดำเนินการ
        </button>
        <button
          type="button"
          role="tab"
          class="segmented-tab teach-compensation-tab"
          [class.active]="activeTab() === 'approved'"
          [attr.aria-selected]="activeTab() === 'approved'"
          (click)="onTabChange('approved')"
        >
          อนุมัติเเล้ว
        </button>
        <button
          type="button"
          role="tab"
          class="segmented-tab teach-compensation-tab"
          [class.active]="activeTab() === 'rejected'"
          [attr.aria-selected]="activeTab() === 'rejected'"
          (click)="onTabChange('rejected')"
        >
          ไม่อนุมัติ
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="teach-compensation-status-badge"
          [class.teach-compensation-status-badge-pending]="row.status === 'submitted' || row.status === 'draft'"
          [class.teach-compensation-status-badge-approved]="row.status === 'approved'"
          [class.teach-compensation-status-badge-rejected]="row.status === 'rejected'"
          [class.teach-compensation-status-badge-revision]="row.status === 'revision_requested'"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="teach-compensation-actions">
          <button
            type="button"
            class="btn teach-compensation-action-button datatable-view-action-button"
            aria-label="ดูคำขอสอนชดเชย"
            (click)="onViewSubmission(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="teach-compensation-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="teach-compensation submission pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>
